import { BreakPoints } from "../types/screen";
import { isTV } from "../utils/platform";

export const MAX_WIDTH_MOBILE = 640;
export const MAX_WIDTH_TABLET = 1279;
export const MAX_WIDTH_MOBILE_LANDSCAPE = 932;
export const MAX_HEIGHT_MOBILE_LANDSCAPE = 450;
export const DEFAULT_HEIGHT_DESKTOP = 1080;

export const isDesktop = window.innerWidth > MAX_WIDTH_TABLET || isTV;
export const isMobile = window.innerWidth < MAX_WIDTH_MOBILE;
export const isTablet = !isMobile && !isDesktop;
export const isTabletLandscape =
  isTablet && window.innerWidth > window.innerHeight;
export const MAX_WIDTH_720P = 1366;
export const MAX_HEIGHT_720P = 768;

export const is720pResolution =
  window.innerWidth > MAX_WIDTH_TABLET &&
  window.innerWidth <= MAX_WIDTH_720P &&
  window.innerHeight <= MAX_HEIGHT_720P;

export const BREAK_POINTS: BreakPoints = {
  mobile: { minWidth: 0, maxWidth: MAX_WIDTH_MOBILE, rate: 1 },
  tablet: {
    minWidth: MAX_WIDTH_MOBILE + 1,
    maxWidth: MAX_WIDTH_TABLET,
    rate: 1,
  },
  desktop: { minWidth: MAX_WIDTH_TABLET + 1, rate: 1 },
};

/**
 * Mobile breakpoint:
 * - Portrait: width ≤ 640px (standard mobile portrait screens)
 * - Landscape: width ≤ 932px AND height ≤ 450px
 *   (max-height distinguishes mobile landscape from tablet,
 *    since tablets have much taller screens even in portrait)
 */
export const BreakPointMobile = `@media (max-width: ${MAX_WIDTH_MOBILE}px), (max-width: ${MAX_WIDTH_MOBILE_LANDSCAPE}px) and (max-height: ${MAX_HEIGHT_MOBILE_LANDSCAPE}px)`;

/**
 * Tablet breakpoint:
 * - Width > 640px AND portrait orientation, OR
 * - Landscape with width 641–931px AND height > 450px
 *   (covers the gap that is neither mobile landscape — height ≤ 450px —
 *    nor desktop landscape — width ≥ 932px)
 */
export const BreakPointTablet = `@media (min-width: ${
  MAX_WIDTH_MOBILE + 1
}px) and (orientation: portrait), (min-width: ${
  MAX_WIDTH_MOBILE + 1
}px) and (max-width: ${MAX_WIDTH_MOBILE_LANDSCAPE - 1}px) and (min-height: ${
  MAX_HEIGHT_MOBILE_LANDSCAPE + 1
}px) and (orientation: landscape)`;

/**
 * Desktop breakpoint:
 * - Any screen wider than 1279px, OR
 * - Width ≥ 1024px AND landscape orientation
 */
export const BreakPointDesktop = `@media (min-width: ${
  MAX_WIDTH_TABLET + 1
}px), (min-width: ${MAX_WIDTH_MOBILE_LANDSCAPE}px) and (orientation: landscape)`;
